// Component: TemplateList
// Purpose: List container for templates, renders rows and defers empty state to
// parent. Forwards callbacks for delete and preview actions.
import React from 'react';
import TemplateRow from './TemplateRow';

export default function TemplateList({
  templates,
  isLoading,
  onDelete,
  onNewTemplate,
  isAdmin,
  onPreviewImage,
  isDeletingId
}) {
  // If there are no templates, return null as the empty state is handled in parent component
  if (templates.length === 0 && !isLoading) {
    return null;
  }

  // Keep console output minimal in production

  return (
    <div className="rounded-lg border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-900 overflow-hidden">
      {templates.map((template, index) => (
        <div 
          key={template.id}
          className="border-b border-gray-200 dark:border-gray-700 last:border-b-0"
        >
          <TemplateRow
            template={template}
            onDelete={onDelete}
            onPreviewImage={onPreviewImage}
            isDeletingId={isDeletingId}
          />
        </div>
      ))}
    </div>
  );
} 